"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
/**
 * Identifies a player.
 */
var Player;
(function (Player) {
    // The first player.
    Player[Player["Player1"] = 0] = "Player1";
    // The second player.
    Player[Player["Player2"] = 1] = "Player2";
})(Player = exports.Player || (exports.Player = {}));
